import { render, staticRenderFns } from "./bidOpeningHall.vue?vue&type=template&id=558cdf40&scoped=true"
import script from "./bidOpeningHall.vue?vue&type=script&lang=js"
export * from "./bidOpeningHall.vue?vue&type=script&lang=js"
import style0 from "./bidOpeningHall.vue?vue&type=style&index=0&id=558cdf40&prod&lang=less&scoped=true"
import style1 from "./bidOpeningHall.vue?vue&type=style&index=1&id=558cdf40&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558cdf40",
  null
  
)

export default component.exports